import styled from "styled-components";

export const GroupHeader = styled.div`
  /* border: 2px dashed; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* height: 2.5rem; */
  margin-bottom: 2rem;
`
export const GroupsLoading = styled.h2`
  margin-top: 4.5rem;
`